import React from "react";

const Footer = ({ language }) => {
  const content = {
    es: {
      business: "ProntoFix Valencia",
      tagline: "Manitas profesional en Valencia",
      rights: "Todos los derechos reservados",
    },
    en: {
      business: "ProntoFix Valencia",
      tagline: "Professional handyman in Valencia",
      rights: "All rights reserved",
    },
  };

  const currentContent = content[language];
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Business Name */}
          <h3 className="text-xl font-bold text-white mb-2">
            <span className="text-[#2563EB]">Pronto</span>Fix Valencia
          </h3>
          
          {/* Tagline */}
          <p className="text-gray-400 mb-4">{currentContent.tagline}</p>

          {/* Phone */}
          <a
            href="tel:+34722886101"
            className="text-[#2563EB] hover:text-blue-400 font-medium inline-block mb-6"
          >
            +34 722 886 101
          </a>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-6">
            <p className="text-sm text-gray-500">
              &copy; {year} {currentContent.business}. {currentContent.rights}.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
